import {takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {tablesAction} from 'utils/tables';

import {adminAction, GetRoleUnassignedPermissionsAction} from '../action';

const tableId = 'roleUnassignedPermissions';

function* execute({payload: {roleId, tableDataRequest}}: GetRoleUnassignedPermissionsAction): SagaIterator {
    yield* put(tablesAction.getTableData({
        tableDataRequest,
        apiRequest: Api.getPermissionsUnassignedToRole,
        successAction: adminAction.getRoleUnassignedPermissionsSuccess,
        tableId,
        pathParams: {roleId},
    }));
}

/** Runs the admin saga that loads permissions that can still be assigned to the selected role. */
export function* getRoleUnassignedPermissionsV2Saga(): SagaIterator {
    yield takeLatestF('admin/GET_ROLE_UNASSIGNED_PERMISSIONS', execute);
}
